import React, { useEffect } from 'react';
import Add from './Add';
import { useAudioCat } from './AudioCatState';
import { Button, List } from 'antd';
import { ArrowRightOutlined, DeleteOutlined } from '@ant-design/icons';

function AudioCat({setCat}) {
    let { cats, setCats, delCat } = useAudioCat()
    useEffect(() => {
        setCats()
    }, [setCats])
    return (
        <div style={{ padding: '35px 25px' }}>
            <Add />
            <List
                dataSource={cats}
                renderItem={(item) => (
                    <List.Item>
                        <Button style={{ marginRight: '10px' }} type="primary" danger icon={<DeleteOutlined />} onClick={() => { delCat(item.id) }} />
                        <List.Item.Meta
                            title={item.name}
                        />
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <Button type="primary" icon={<ArrowRightOutlined />} onClick={() => { setCat(item.id) }} />
                        </div>
                    </List.Item>
                )}
            />
        </div>
    );
}

export default AudioCat;